import { useState, useEffect } from "react";
import Topbar from "./topBar";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import Sidebar from "./sideBar";
import axios from "axios";
import { API as url1 } from "../../config";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { FiEdit2, FiEye } from "react-icons/fi";
import { FaImage } from "react-icons/fa";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Tooltip } from "react-tooltip";
import { IoSearch } from "react-icons/io5";
import { toast, Bounce } from "react-toastify";
import {
  Tab,
  Box,
  Button,
  InputLabel,
  ListItemText,
  Autocomplete,
  Chip,
  Grid,
  FormControl,
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Modal,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { KEYWORDS, LANGUAGE, ADD_EMPLOYEE, DIS_BUY, IN_BUY, DIS_SELL, IN_SELL, DEACT, ACTIVE, EDIT, VIEW_DET, VIEW_IMG } from "../../constants/url";
import { privateApiCall } from "../../api/privateApi";
import {
  CONFIRM_PASSWORD_ERR,
  ERR_ALERT_TITLE,
  SUCC_ALERT_TITLE,
} from "../../constants/alertMessage";
import ImageModal from "../../images/imageModal";
import { getStatusString } from "../../constants/enumConstants";

const cookies = new Cookies();
const Marketplace = () => {
  const [imageSrcc, setImageSrcc] = useState("");
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const handleClose1 = () => setOpen1(false);
  const [details, setDetails] = useState({});
  const handleClose = () => setOpen(false);
  const [orgName, setOrgName] = useState("");
  const [buyPId, setBuyPId] = useState(null);
  const [orgMobile, setOrgMobile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [org_id, setOrgid] = useState(cookies.get("org_id"));
  // this state for updating the active keywords from the api call
  const [newKeyword, setNewKeyword] = useState([]);
  // this state is for selected keywords from the dropdownlist
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [sellShow, setSellshow] = useState(false);
  const [sellPId, setSellPId] = useState(null);
  const [sellProducts, setSellProducts] = useState([]);
  const [sellView, setSellView] = useState(false);
  const handleSellViewClose = () => setSellView(false);
  const [sellDetails, setSellDetails] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [activeLanguages, setActiveLanguages] = useState([]);
  // adding new keywords for the modal
  const [keyword, setKeyword] = useState("");
  const [value, setValue] = useState("1");
  const [formData, setFormData] = useState({
    title: "",
    img1: "",
    unit: "",
    quantity: "",
    startDate: "",
    endDate: "",
    location: "",
    description: "",
    org_id: cookies.get("org_id"),
  });
  const [values, setValues] = useState({
    data: [],
    success: false,
    removed: false,
    img1: "",
    img2: "",
    img3: "",
    img4: "",
    keywords: "",
    title: "",
    description: "",
    qty: "",
    price: "",
    unit: "Kg",
    location: "",
    latitude: "",
    longitude: "",
    expdate: "",
    availableDate: "",
    auction_status: 0,
    organic_status: 0,
    safe_status: 0,
    transpot_status: 0,
    chargesAfter: "",
    freeDelivery: "",
    startDate: "",
    endDate: "",
    org_id: cookies.get("org_id"),
  });
  const [open2, setOpen2] = useState(false);
  const handleOpenClose = () => setOpen2(false);
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [image4, setImage4] = useState("");

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filterSell, setFilterSell] = useState([]);

  useEffect(() => {
    fetchAllData();
  }, []);
  const handleSellshow = () => {
    setSellshow(true);
    setValues({
      ...values,
      img1: "",
      img2: "",
      img3: "",
      img4: "",
      keywords: "",
      title: "",
      description: "",
      qty: "",
      price: "",
      unit: "",
      location: "",
      latitude: "",
      longitude: "",
      expdate: "",
      availableDate: "",
      auction_status: 0,
      organic_status: 0,
      safe_status: 0,
      transpot_status: 0,
      chargesAfter: "",
      freeDelivery: "",
    });
    setSellPId(null);
    setSelectedKeyword([]);
  };
  const handleModalClose = () => {
    setShowModal(false);
    setKeyword("");
    setSelectedLanguage("");
  };
  const handleModalOpen = () => setShowModal(true);
  const handleChanges = (event, newValue) => {
    setValue(newValue);
  };
  const handleShowClose = () => {
    setFormData({
      title: "",
      unit: "",
      img1: "",
      quantity: "",
      startDate: "",
      endDate: "",
      location: "",
      description: "",
    });
    setBuyPId(null);
    document.getElementById("image").value = "";
    setShow(false);
    setSelectedKeyword([]);
  };
  const handleShowClose1 = () => {
    // setSellPId(null)
    setSellshow(false);
  };
  const onFileChange1 = (e) => {
    setValues({
      ...values,
      error: false,
      img1: URL.createObjectURL(e.target.files[0]),
    });
    setImage1(e.target.files[0]);
  };
  const onFileChange2 = (e) => {
    setValues({
      ...values,
      error: false,
      img2: URL.createObjectURL(e.target.files[0]),
    });
    setImage2(e.target.files[0]);
  };
  const onFileChange3 = (e) => {
    setValues({
      ...values,
      error: false,
      img3: URL.createObjectURL(e.target.files[0]),
    });
    setImage3(e.target.files[0]);
  };
  const onFileChange4 = (e) => {
    setValues({
      ...values,
      error: false,
      img4: URL.createObjectURL(e.target.files[0]),
    });
    setImage4(e.target.files[0]);
  };
  console.log(image1,image2,image3,image4,"all images updated in the state...")
  const handleChange = (name) => (e) => {
    setValues({ ...values, error: false, [name]: e.target.value });
  };
  const handleCheckBoxChange = (name, value) => (e) => {
    setValues({ ...values, [name]: e.target.checked ? value : 0 });
  };

 

  const fetchAllData = async () => {
    try {
      const requestUrl = `/api/organisation/getMarketplaceApi?org_id=${org_id}`;
      const response = await privateApiCall(requestUrl, "GET");
      console.log(response,"response...")
     
      if (response.status == 200) {
        const { activeLanguages, activeKeywords, buyProducts, sellProducts } =
          response.data.data;

        // Update state with the retrieved data
        setNewKeyword([...activeKeywords, { keywords: "Other" }]);
        setActiveLanguages(activeLanguages);
        setProducts(buyProducts);
        setFilteredProducts(buyProducts);
        setSellProducts(sellProducts);
        setFilterSell(sellProducts);
      } else {
        console.log("else case is working")
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: "error",
          text: response.data.msg,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.log("catch block is working.....")
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        icon: "error",
        text: error.message || `${CONFIRM_PASSWORD_ERR}`,
        confirmButtonText: "OK",
      });
    }
  };
  const handleModalSubmit = async () => {
    try {
      const requestUrl = `${KEYWORDS}/addKeyword`;

      const response = await privateApiCall(requestUrl, "POST", {
        keyword: keyword,
        languageCode: selectedLanguage,
        status: "inactive",
      });

      if (response.status === 200) {
        // console.log("sucess added");
        Swal.fire({
          title: `${SUCC_ALERT_TITLE}`,
          text: response?.data?.message,
          icon: "success",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
        setShowModal(false);
        setKeyword("");
        setSelectedLanguage("");
      } else {
        console.log("error");
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: "error",
          text: response.data.message,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      if (error.response) {
        Swal.fire({
          title: "Error",
          icon: "error",
          text: error.response?.data?.message,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    }
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const [imageURL,setImageURL]=useState("")
  const handleImageChange = (file) => {
    setFormData({
      ...formData,
      img1: file,
    });
    setImageURL(URL.createObjectURL(file))
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { location } = formData;
      getLocationCoordinates(location)
        .then(({ latitude, longitude }) => {
          const formDataWithCoordinates = new FormData();
          formDataWithCoordinates.append("image1", formData.img1);
          formDataWithCoordinates.append("title", formData.title);
          formDataWithCoordinates.append("unit", formData.unit);
          formDataWithCoordinates.append("qty", formData.quantity);
          formDataWithCoordinates.append("startDate", formData.startDate);
          formDataWithCoordinates.append("endDate", formData.endDate);
          formDataWithCoordinates.append("location", formData.location);
          formDataWithCoordinates.append("description", formData.description);
          formDataWithCoordinates.append(
            "selectedKeyword",
            selectedKeyword.map((keyword) => keyword.keywords)
          );
          formDataWithCoordinates.append("latitude", latitude);
          formDataWithCoordinates.append("longitude", longitude);
          formDataWithCoordinates.append("org_id", org_id);
          const requestUrl = `${ADD_EMPLOYEE}/addBuyproduct`;
          return privateApiCall(requestUrl, "POST", formDataWithCoordinates);
        })
        .then((response) => {
          if (response.status === 200) {
            setShow(false);
            return Swal.fire({
              icon: "success",
              title: `${SUCC_ALERT_TITLE}`,
              text: response.data.msg,
              confirmButtonText: "OK",
            });
          } else {
            setShow(false);
            return Swal.fire({
              icon: "error",
              title: `${ERR_ALERT_TITLE}`,
              text: response.data.message,
            });
          }
        })
        .then(() => {
          fetchAllData();
        })
        .catch((error) => {
          setShow(false);
          Swal.fire({
            icon: "error",
            title: `${ERR_ALERT_TITLE}`,
            text: "Something went wrong!",
          });
        });
    } catch (error) {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: `${ERR_ALERT_TITLE}`,
      });
    }
  };
  const handleEditSubmit = async (event) => {
    event.preventDefault();
    try {
      const { location } = formData;
      getLocationCoordinates(location)
        .then(({ latitude, longitude }) => {
          const formDataWithCoordinates = new FormData();
          formDataWithCoordinates.append("image1", formData.img1);
          formDataWithCoordinates.append("title", formData.title);
          formDataWithCoordinates.append("unit", formData.unit);
          formDataWithCoordinates.append("qty", formData.quantity);
          formDataWithCoordinates.append("startDate", formData.startDate);
          formDataWithCoordinates.append("endDate", formData.endDate);
          formDataWithCoordinates.append("location", formData.location);
          formDataWithCoordinates.append("description", formData.description);
          formDataWithCoordinates.append(
            "selectedKeyword",
            selectedKeyword.map((keyword) => keyword.keywords)
          );
          formDataWithCoordinates.append("latitude", latitude);
          formDataWithCoordinates.append("longitude", longitude);
          formDataWithCoordinates.append("org_id", org_id);
          const requestUrl = `${ADD_EMPLOYEE}/editBuyproduct/${buyPId}`;

          return privateApiCall(requestUrl, "PUT", formDataWithCoordinates);
        })
        .then((response) => {
          if (response.data.status === true) {
            setShow(false);
            return Swal.fire({
              icon: "success",
              title: "Success",
              text: response.data.msg,
              confirmButtonText: "OK",
            });
          } else {
            return Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        })
        .then(() => {
          fetchAllData();
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    } catch (error) {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: `${ERR_ALERT_TITLE}`,
        text: "Something went wrong!",
      });
    }
  };

  const getLocationCoordinates = async (location) => {
    try {
      const encodedLocation = encodeURIComponent(location);
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedLocation}&key=AIzaSyDF3a-GQ5R9FXbaElMErkekO5Kkp38Z8eY`
      );
      if (response.data.status === "OK") {
        const { lat, lng } = response.data.results[0].geometry.location;
        return { latitude: lat, longitude: lng };
      } else {
        throw new Error("Geocoding API request failed");
      }
    } catch (error) {
      console.error("Error fetching location coordinates:", error);
      throw new Error("Failed to fetch location coordinates");
    }
  };
  const handleSellSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("image1", image1);
      formData.append("image2", image2);
      formData.append("image3", image3);
      formData.append("image4", image4);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append(
        "selectedKeyword",
        selectedKeyword.map((keyword) => keyword.keywords)
      );
      formData.append("qty", values.qty);
      formData.append("price", values.price);
      formData.append("location", values.location);
      formData.append("unit", values.unit);
      formData.append("org_id", values.org_id);
      const { latitude, longitude } = await getLocationCoordinates(
        values.location
      );
      formData.append("latitude", latitude);
      formData.append("longitude", longitude);
      formData.append("expDate", values.expdate);
      formData.append("availableDate", values.availableDate);
      formData.append("auction_status", values.auction_status);
      formData.append("organic_status", values.organic_status);
      formData.append("safe_status", values.safe_status);
      formData.append("transpot_status", values.transpot_status);
      formData.append("chargesAfter", values.chargesAfter);
      formData.append("freeDelivery", values.freeDelivery);
      const requestUrl = `${ADD_EMPLOYEE}/addSellproduct`;
      const response = await privateApiCall(requestUrl, "POST", formData);
      if (!response.data.status) {
        setSellshow(false);
        Swal.fire({
          title: response.data.msg,
          text: "",
          icon: "error",
          confirmButtonText: "Ok",
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      } else {
        setSellshow(false);
        Swal.fire({
          title: response.data.msg,
          text: "",
          icon: "success",
          confirmButtonText: "Ok",
          showCancelButton: false,
        });
        fetchAllData();
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };
  console.log(image1,image2,image3,image4,"------")
  const handleEditSellSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("image1", image1);
      formData.append("image2", image2);
      formData.append("image3", image3);
      formData.append("image4", image4);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append(
        "selectedKeyword",
        selectedKeyword.map((keyword) => keyword.keywords)
      );
      formData.append("qty", values.qty);
      formData.append("price", values.price);
      formData.append("location", values.location);
      formData.append("unit", values.unit);
      formData.append("org_id", values.org_id);
      const { latitude, longitude } = await getLocationCoordinates(
        values.location
      );
      formData.append("latitude", latitude);
      formData.append("longitude", longitude);
      formData.append("expDate", values.expdate);
      formData.append("availableDate", values.availableDate);
      formData.append("auction_status", values.auction_status);
      formData.append("organic_status", values.organic_status);
      formData.append("safe_status", values.safe_status);
      formData.append("transpot_status", values.transpot_status);
      formData.append("chargesAfter", values.chargesAfter);
      formData.append("freeDelivery", values.freeDelivery);
      const requestUrl = `${ADD_EMPLOYEE}/editSellproduct/${sellPId}`;
      const response = await privateApiCall(requestUrl, "PUT", formData);
      console.log(response, "edit sell success");
      if (!response.data.status) {
        setSellshow(false);
        toast
          .error(response.data.message, {
            position: "top-right",
            transition: Bounce,
          })
          .then((result) => {
            if (result.isConfirmed) {
              fetchAllData();
            }
          });
      } else {
        setSellshow(false);
        toast.info(response.data.msg, {
          position: "top-right",
          transition: Bounce,
        });
        fetchAllData();
      }
    } catch (error) {}
  };
  const Actions = ({ row }) => {
    console.log(row.image1,"row.image1")
    const handleImageClick = () => {
      console.log(row.image1,"row.image1")
      if(row.image1){
      setImageSrcc(row.image1);
      setOpen(true);
      }
    };
    const handleEditShow = (e) => {
      setBuyPId(row._id);
      setShow(true);
      setFormData({
        ...formData,
        title: row.title,
        quantity: row.qty,
        description: row.description,
        startDate: row.startDate,
        endDate: row.endDate,
        location: row.location,
        unit: row.unit,
        img1: row.image1,
      });
      setImageURL(row.image1)
      
      setSelectedKeyword(
        row.keywords.map((keyword) => ({ keywords: keyword }))
      );
    };
    const handleView = (e) => {
      console.log(open1, "state changes...");
      setDetails(row);
      setOpen1(true);
    };
  const disableBuy = async () => {
  Swal.fire({
    title: `${DEACT} ${row.title} ?`,
    icon: "question",
    allowOutsideClick: false,
    confirmButtonText: "Yes",
    showCancelButton: true,
  }).then(async (result) => {
    if (result) {
      try {
        const requestUrl = `${DIS_BUY}/${row._id}`;
        const response = await privateApiCall(requestUrl, "POST",null);
        toast.info(response.data.message, {
          position: "top-right",
          transition: Bounce,
        });
        fetchAllData();
      } catch (error) {
        console.log(error,"error")
        Swal.fire({
          icon: "error",
          title: `${ERR_ALERT_TITLE}`,
          text: "Something went wrong!",
        });
      }
    }
  });
};
const EnableBuy = () => {
  Swal.fire({
    title: `${ACTIVE} ${row.title} ?`,
    icon: "question",
    allowOutsideClick: false,
    confirmButtonText: "Yes",
    showCancelButton: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const requestUrl = `${IN_BUY}/${row._id}`;
        const response = await privateApiCall(requestUrl, "POST", null);
        toast.info(response.data.message, {
          position: "top-right",
          transition: Bounce,
        });
        fetchAllData();
      } catch (error) {
        console.log(error, "error");
        Swal.fire({
          icon: "error",
          title: `${ERR_ALERT_TITLE}`,
          text: "Something went wrong!",
        });
      }
    }
  });
};
    return (
      <span>
        <i
          
          data-tooltip-id="1"
          data-tooltip-content={`${EDIT}`}
          onClick={handleEditShow}
        >
          <FiEdit2 size="18px" color="#00C5B2" />
        </i>
        <Tooltip id="1" style={{ fontStyle: "normal" }} />
        <i
           
          data-tooltip-id="2"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handleView} color="#9368f3" size="20" />
        </i>
        <Tooltip id="2" style={{ fontStyle: "normal" }} />
       
        <Tooltip id="3" style={{ fontStyle: "normal" }} />
        {row.delete_status ? (
          <i
            className="ml-2"
            onClick={EnableBuy}
            data-tooltip-id="tooltip1"
            data-tooltip-content={`${ACTIVE}`}
          >
            <FaRegThumbsUp size="18px" color="green" />
          </i>
        ) : (
          <i
            className="ml-2"
            onClick={disableBuy}
            data-tooltip-id="tooltip2"
            data-tooltip-content={`${DEACT}`}
          >
            <FaRegThumbsDown size="18px" color="red" />
          </i>
        )}
        <Tooltip id="tooltip2" style={{ fontStyle: "normal" }} />
        <Tooltip id="tooltip1" style={{ fontStyle: "normal" }} />
        {row.image1 && (
          <i
            className="ml-1"
            data-tooltip-id="3"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleImageClick} color="green" size="17" />
          </i>
        )}

      </span>
    );
  };
  const handleSearchBuy = async (e) => {
    try {
      const value = e.target.value;
      if (value === "") {
        setFilteredProducts(products);
        return;
      }
      const requestUrl = `/api/organisation/${org_id}/search/${value}`;
      const response = await privateApiCall(requestUrl, "GET");
      setFilteredProducts(response.data.data);
    } catch (error) {
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  const Action = ({ row }) => {
    const handleSellImageClick = () => {
      setOpen2(true);
      setImage1(row.image1);
      setImage2(row.image2);
      setImage3(row.image3);
      setImage4(row.image4);
    };
    
    const handleEditSellShow = (e) => {
      console.log(row, "checking  edit.");
      setSellPId(row._id);
      setSellshow(true);
      setValues({
        ...values,
        title: row.title,
        description: row.description,
        price: row.price,
        img1: row.image1,
        img2: row.image2,
        img3: row.image3,
        img4: row.image4,
        unit: row.unit,
        location: row.location,
        expDate: row.expDate,
        availableDate: row.availableDate,
        keywords: row.keywords,
        qty: row.qty,
        auction_status: row.auction_status,
        organic_status: row.organic_status,
        safe_status: row.safe_status,
        transpot_status: row.transpot_status,
        chargesAfter: row.chargesAfter,
        freeDelivery: row.freeDelivery,
      });
      setSelectedKeyword(
        row.keywords.map((keyword) => ({ keywords: keyword }))
      );
    };
    const handleSellView = (e) => {
      setSellDetails(row);
      setSellView(true);
    };
    const disableSell = async () => {
      Swal.fire({
        title: `Disable ${row.title} ?`,
        icon: "question",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            
            const requestUrl = `${DIS_SELL}/${row._id}`;
            const response = await privateApiCall(requestUrl, "POST", null);
            toast.info(response.data.message, {
              position: "top-right",
              transition: Bounce,
            });
            fetchAllData();
          } catch (error) {
            console.log(error, "error");
            Swal.fire({
              icon: "error",
              title: `${ERR_ALERT_TITLE}`,
              text: "Something went wrong!",
            });
          }
        }
      });
    };
    const EnableSell = () => {
      Swal.fire({
        title: `Enable ${row.title} ?`,
        icon: "question",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const requestUrl=`${IN_SELL}/${row._id}`
            const response=await privateApiCall(requestUrl,"POST",null)
            toast.info(response.data.message, {
              position: "top-right",
              transition: Bounce,
            });
            fetchAllData();
          } catch (error) {
           
            Swal.fire({
              icon: "error",
              title: `${ERR_ALERT_TITLE}`,
              text: "Something went wrong!",
            });
            
          }
           
           
        }
      });
    };
    return (
      <span>
        <i
          
          data-tooltip-id="1"
          data-tooltip-content={`${EDIT}`}
          onClick={handleEditSellShow}
        >
          <FiEdit2 size="18px" color="#00C5B2" />
        </i>
        <Tooltip id="1" style={{ fontStyle: "normal" }} />
        <i
           
          data-tooltip-id="2"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handleSellView} color="#9368f3" size="20" />
        </i>
        <Tooltip id="2" style={{ fontStyle: "normal" }} />
       
        <Tooltip id="3" style={{ fontStyle: "normal" }} />
        {row.delete_status ? (
          <i
            className="ml-2"
            onClick={EnableSell}
            data-tooltip-id="tooltip1"
            data-tooltip-content={`${ACTIVE}`}
          >
            <FaRegThumbsUp size="18px" color="green" />
          </i>
        ) : (
          <i
            className="ml-2"
            onClick={disableSell}
            data-tooltip-id="tooltip2"
            data-tooltip-content={`${DEACT}`}
          >
            <FaRegThumbsDown size="18px" color="red" />
          </i>
        )}
        <Tooltip id="tooltip2" style={{ fontStyle: "normal" }} />
        <Tooltip id="tooltip1" style={{ fontStyle: "normal" }} />
        {row.image1 && (
          <i
            className="ml-1"
            data-tooltip-id="3"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleSellImageClick} color="green" size="17" />
          </i>
        )}
      </span>
    );
  };
console.log(values.img1,"image1",values.img2,"image2",values.img3,"image3",values.img4,"image4")
  const imageSources = [image1, image2, image3, image4];
  const handleSearchSell = async (e) => {
    try {
      const value = e.target.value;
     
      if (value === "") {
        setFilterSell(sellProducts);
        return;
      }
      const requestUrl = `/api/organisation/${org_id}/searchSell/${value}`;
      const response = await privateApiCall(requestUrl, "GET");
       
      setFilterSell(response.data.data);
    } catch (error) {}
  };
  console.log(imageSrcc,"customer name and mobile number")
  return (
    <div id="wrapper">
      <Topbar
        backgroundColor="#0baae5"
        setMobile={setOrgMobile}
        setName={setOrgName}
      />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left">Market Place</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to="/organisation/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Market Place</li>
                  </ol>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card-box">
                  <div className="row">
                    <div className="col-12">
                      <div className="p-20">
                        {/* -------------------------------------------------------------------- */}
                        <TabContext value={value}>
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <TabList
                              onChange={handleChanges}
                              aria-label="lab API tabs example"
                            >
                              <Tab label="Buy Proudcts" value="1" />
                              <Tab label="Sell Products" value="2" />
                              <Tab label="Payment" value="3" />
                            </TabList>
                          </Box>
                          <TabPanel value="1">
                            <Box display="flex" justifyContent="space-between">
                              <Button
                                variant="contained"
                                sx={{
                                  padding: "6px 16px",
                                  backgroundColor: "#0baae5",
                                  color: "#fff",
                                  margin: "9px 0",
                                  "&:hover": {
                                    backgroundColor: "#0baae5", // Same as the default background color
                                  },
                                }}
                                onClick={handleShow}
                              >
                                + Add Buy Product
                              </Button>
                              <div
                                style={{
                                  position: "relative",
                                  float: "right",
                                  width: "200px",
                                }}
                              >
                                <IoSearch
                                  style={{
                                    position: "absolute",
                                    left: "10px",
                                    top: "35%",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                                <input
                                  type="text"
                                  placeholder="Search BuyProducts"
                                  className="form-control"
                                  style={{
                                    paddingLeft: "30px",
                                  }}
                                  onChange={handleSearchBuy}
                                />
                              </div>
                            </Box>
                            {/* Buy Add and Edit Modal */}
                            <Modal
                              open={show}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "100px",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "900px",
                                  backgroundColor: "white",
                                  padding: "20px",
                                  borderRadius: "8px",
                                  boxShadow: 24,
                                  outline: "none",
                                }}
                              >
                                <h3>
                                  {buyPId
                                    ? "Edit BuyProduct"
                                    : "Add BuyProduct"}
                                </h3>
                                <form
                                  onSubmit={
                                    buyPId ? handleEditSubmit : handleSubmit
                                  }
                                >
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={4}>
                                      {formData.img1 !== "" ? (
                                        <img
                                        src={imageURL}
                                          alt=""
                                          height="150px"
                                          width="100%"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/icons/try.jpg"
                                          alt=""
                                          height="150px"
                                          width="100%"
                                        />
                                      )}
                                      <div className="mt-3">
                                        <input
                                          type="file"
                                          id="image"
                                          name="image1"
                                          className="mt-3 mb-3"
                                          onChange={(e) =>
                                            handleImageChange(e.target.files[0])
                                          }
                                          accept="image/png, image/jpeg"
                                        />
                                      </div>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        placeholder="Enter Title"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <Autocomplete
                                        multiple
                                        id="tags-outlined"
                                        options={newKeyword}
                                        value={selectedKeyword}
                                        getOptionLabel={(option) =>
                                          option.keywords
                                        }
                                        defaultValue={[]}
                                        filterSelectedOptions
                                        onChange={(event, value) => {
                                          console.log(value, "-----");
                                          if (
                                            value.some(
                                              (option) =>
                                                option.keywords === "Other"
                                            )
                                          ) {
                                            handleModalOpen();
                                          } else {
                                            setSelectedKeyword(value);
                                          }
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Keywords"
                                            placeholder="Select Your keyword"
                                          />
                                        )}
                                      />
                                      {/*  Add Keyword for Buy */}
                                      <Modal
                                        open={showModal}
                                        onClose={handleModalClose}
                                        aria-labelledby="simple-modal-title"
                                        aria-describedby="simple-modal-description"
                                      >
                                        <div
                                          style={{
                                            padding: "20px",
                                            background: "white",
                                            width: "60%",
                                            margin: "100px auto",
                                            position: "absolute",
                                            top: "40%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                          }}
                                        >
                                          <h2> Add Keyword</h2>

                                          <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField
                                              label="Keyword"
                                              type="text"
                                              value={keyword}
                                              onChange={(e) =>
                                                setKeyword(e.target.value)
                                              }
                                              required
                                              style={{ marginTop: "20px" }}
                                            />
                                          </FormControl>
                                          <FormControl fullWidth sx={{ mb: 3 }}>
                                            <InputLabel id="language-label">
                                              Select Language
                                            </InputLabel>
                                            <Select
                                              labelId="language-label"
                                              value={selectedLanguage}
                                              onChange={(e) =>
                                                setSelectedLanguage(
                                                  e.target.value
                                                )
                                              }
                                              required
                                            >
                                              <MenuItem value="">
                                                <em>Select Language</em>
                                              </MenuItem>
                                              {activeLanguages.map((lang) => (
                                                <MenuItem
                                                  key={lang._id}
                                                  value={lang.language}
                                                >
                                                  {lang.language}-{lang.code}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                          <Grid
                                            container
                                            justifyContent="flex-end"
                                            sx={{ mt: 3 }}
                                          >
                                            <Button
                                              variant="outlined"
                                              color="error"
                                              onClick={handleModalClose}
                                              sx={{ mt: 2, mr: 1 }}
                                            >
                                              Close
                                            </Button>
                                            <Button
                                              type="submit"
                                              variant="contained"
                                              color="success"
                                              sx={{ mt: 2 }}
                                              style={{
                                                backgroundColor: "#0BAAE5",
                                              }}
                                              onClick={handleModalSubmit}
                                            >
                                              Add
                                            </Button>
                                          </Grid>
                                        </div>
                                      </Modal>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <FormControl fullWidth>
                                        <InputLabel>Unit</InputLabel>
                                        <Select
                                          value={formData.unit}
                                          onChange={handleInputChange}
                                          name="unit"
                                        >
                                          <MenuItem value="">
                                            Select Unit
                                          </MenuItem>
                                          {[
                                            "Kg",
                                            "Gram",
                                            "Nos",
                                            "Litre",
                                            "Ml",
                                            "Bottle",
                                            "Packet",
                                            "Tonne",
                                          ].map((unit, index) => (
                                            <MenuItem key={index} value={unit}>
                                              {unit}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label="Quantity"
                                        name="quantity"
                                        value={formData.quantity}
                                        placeholder="Enter Quantity"
                                        onChange={handleInputChange}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="date"
                                        // label="Start Date"
                                        name="startDate"
                                        value={formData.startDate}
                                        placeholder="Enter Available Date"
                                        onChange={handleInputChange}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="date"
                                        // label="End Date"
                                        name="endDate"
                                        value={formData.endDate}
                                        placeholder="Enter Expiry Date"
                                        onChange={handleInputChange}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Location"
                                        name="location"
                                        value={formData.location}
                                        placeholder="Enter Location"
                                        onChange={handleInputChange}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        value={formData.description}
                                        placeholder="Enter Description"
                                        onChange={handleInputChange}
                                        required
                                      />
                                    </Grid>
                                  </Grid>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      onClick={handleShowClose}
                                      sx={{ mt: 2, mr: 1 }}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      sx={{ mt: 2, mr: 1 }}
                                      style={{
                                        backgroundColor: "#0BAAE5",
                                        marginRight: "10px",
                                      }}
                                    >
                                      {buyPId ? "Update" : "Submit"}
                                    </Button>
                                  </div>
                                </form>
                              </Box>
                            </Modal>
                            <TableContainer>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell width="80px" align="center">
                                      S.No
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Title
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Customer
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Status
                                    </TableCell>

                                    <TableCell width="80px" align="left">
                                      Actions
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredProducts.map((product, index) => (
                                    <TableRow key={product._id}>
                                      <TableCell width="80px" align="center">
                                        {index + 1}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        {product.title}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        {product.customer}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                      {getStatusString(product.status)}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        <Actions row={product} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                  {/* Buy View Details Modal */}
                                  <Modal
                                    open={open1}
                                    onClose={handleClose1}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                  >
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "80vw",
                                        maxHeight: "80vh",
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 4,
                                        overflowY: "auto",
                                      }}
                                    >
                                      <Grid
                                        container
                                        justifyContent="center"
                                        alignItems="center"
                                        className="modal-content"
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-header"
                                        >
                                          <Typography
                                            id="modal-title"
                                            variant="h6"
                                            component="h2"
                                          >
                                            Details
                                          </Typography>
                                          <Button
                                            onClick={handleClose1}
                                            color="inherit"
                                          >
                                            <span
                                              style={{ fontSize: "20px" }}
                                              aria-hidden="true"
                                            >
                                              &#128473;
                                            </span>
                                          </Button>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-body"
                                        >
                                          <Table className="col-12">
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Title
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.title}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Description
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.description}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                startDate
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.startDate}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                EndDate
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.endDate}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                location
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.location}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                latitude
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.latitude}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                longitude
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.longitude}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                keywords
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.keywords
                                                  ? details.keywords.join(", ")
                                                  : "No keywords available"}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                unit
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.unit}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Quantity
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {details.qty}
                                              </TableCell>
                                            </TableRow>
                                          </Table>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-footer"
                                        >
                                          <Button
                                            onClick={handleClose1}
                                            variant="outlined"
                                            color="error"
                                          >
                                            Close
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Modal>
                                  <ImageModal 
                                  handleClose={handleClose}
                                  open={open}
                                    imageSrc={[imageSrcc]}
                                     ></ImageModal>
                                   
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabPanel>

                          <TabPanel value="2">
                            <Box display="flex" justifyContent="space-between">
                              <Button
                                variant="contained"
                                sx={{
                                  padding: "6px 16px",
                                  backgroundColor: "#0baae5",
                                  color: "#fff",
                                  margin: "9px 0",
                                  "&:hover": {
                                    backgroundColor: "#0baae5", // Same as the default background color
                                  },
                                }}
                                onClick={handleSellshow}
                              >
                                + Add Sell Product
                              </Button>
                              <div
                                style={{
                                  position: "relative",
                                  float: "right",
                                  width: "200px",
                                }}
                              >
                                <IoSearch
                                  style={{
                                    position: "absolute",
                                    left: "10px",
                                    top: "35%",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                                <input
                                  type="text"
                                  placeholder="Search SellProducts"
                                  className="form-control"
                                  style={{
                                    paddingLeft: "30px",
                                  }}
                                  onChange={handleSearchSell}
                                />
                              </div>
                            </Box>
                            {/* Sell Add and Edit Modal */}
                            <Modal
                              open={sellShow}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "100px",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  width: "80vw",

                                  backgroundColor: "white",
                                  padding: "30px",
                                  borderRadius: "8px",
                                  boxShadow: 24,
                                  outline: "none",
                                }}
                              >
                                <h3>
                                  {sellPId
                                    ? "Edit Sell Product"
                                    : "Add Sell Product"}
                                </h3>
                                <form
                                  onSubmit={
                                    sellPId
                                      ? handleEditSellSubmit
                                      : handleSellSubmit
                                  }
                                >
                                  <Grid container spacing={3}>
                                  <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 1
                        </div>

                        {values.img1 !== "" ? (
                          <div>
                            <img
                              src={values.img1}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            onChange={onFileChange1}
                            accept="image/png,  image/jpeg"
                            className="mt-3 margin-top-10"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 2
                        </div>

                        {values.img2 !== "" ? (
                          <div>
                            <img
                              src={values.img2}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange2}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 3
                        </div>

                        {values.img3 !== "" ? (
                          <div>
                            <img
                              src={values.img3}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange3}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 4
                        </div>

                        {values.img4 !== "" ? (
                          <div>
                            <img
                              src={values.img4}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange4}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                                  </Grid>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Title"
                                        name="title"
                                        value={values.title}
                                        onChange={handleChange("title")}
                                        placeholder="Enter Title"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <Autocomplete
                                        multiple
                                        id="tags-outlined"
                                        options={newKeyword}
                                        value={selectedKeyword}
                                        getOptionLabel={(option) =>
                                          option.keywords
                                        }
                                        defaultValue={[]}
                                        filterSelectedOptions
                                        onChange={(event, value) => {
                                          if (
                                            value.some(
                                              (option) =>
                                                option.keywords === "Other"
                                            )
                                          ) {
                                            handleModalOpen();
                                          } else {
                                            setSelectedKeyword(value);
                                          }
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Keywords"
                                            placeholder="Select Your keyword"
                                          />
                                        )}
                                      />
                                      {/*Sell add Keyword */}
                                      <Modal
                                        open={showModal}
                                        onClose={handleModalClose}
                                        aria-labelledby="simple-modal-title"
                                        aria-describedby="simple-modal-description"
                                      >
                                        <div
                                          style={{
                                            padding: "20px",
                                            background: "white",
                                            width: "60%",
                                            margin: "100px auto",
                                            position: "absolute",
                                            top: "40%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                          }}
                                        >
                                          <h2> Add Keyword</h2>
                                          <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField
                                              label="Keyword"
                                              type="text"
                                              value={keyword}
                                              onChange={(e) =>
                                                setKeyword(e.target.value)
                                              }
                                              required
                                              style={{ marginTop: "20px" }}
                                            />
                                          </FormControl>
                                          <FormControl fullWidth sx={{ mb: 3 }}>
                                            <InputLabel id="language-label">
                                              Select Language
                                            </InputLabel>
                                            <Select
                                              labelId="language-label"
                                              value={selectedLanguage}
                                              onChange={(e) =>
                                                setSelectedLanguage(
                                                  e.target.value
                                                )
                                              }
                                              required
                                            >
                                              <MenuItem value="">
                                                <em>Select Language</em>
                                              </MenuItem>
                                              {activeLanguages.map((lang) => (
                                                <MenuItem
                                                  key={lang._id}
                                                  value={lang.language}
                                                >
                                                  {lang.language}-{lang.code}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                          <Grid
                                            container
                                            justifyContent="flex-end"
                                            sx={{ mt: 3 }}
                                          >
                                            <Button
                                              variant="outlined"
                                              color="error"
                                              onClick={handleModalClose}
                                              sx={{ mt: 2, mr: 1 }}
                                            >
                                              Close
                                            </Button>
                                            <Button
                                              type="submit"
                                              variant="contained"
                                              color="success"
                                              sx={{ mt: 2 }}
                                              style={{
                                                backgroundColor: "#0BAAE5",
                                              }}
                                              onClick={handleModalSubmit}
                                            >
                                              Add
                                            </Button>
                                          </Grid>
                                        </div>
                                      </Modal>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <FormControl fullWidth>
                                        <InputLabel>Unit</InputLabel>
                                        <Select
                                          value={values.unit}
                                          onChange={handleChange("unit")}
                                          name="unit"
                                        >
                                          <MenuItem value="">
                                            Select Unit
                                          </MenuItem>
                                          {[
                                            "Kg",
                                            "Gram",
                                            "Nos",
                                            "Litre",
                                            "Ml",
                                            "Bottle",
                                            "Packet",
                                            "Tonne",
                                          ].map((unit, index) => (
                                            <MenuItem key={index} value={unit}>
                                              {unit}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label="Quantity"
                                        name="quantity"
                                        value={values.qty}
                                        placeholder="Enter Quantity"
                                        onChange={handleChange("qty")}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        name="price"
                                        label="Price"
                                        value={values.price}
                                        onChange={handleChange("price")}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="date"
                                        name="availableDate"
                                        
                                        value={values.availableDate}
                                        onChange={handleChange("availableDate")}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        type="date"
                                        name="expdate"
                                        
                                        value={values.expdate}
                                        onChange={handleChange("expdate")}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Location"
                                        name="location"
                                        value={values.location}
                                        placeholder="Enter Location"
                                        onChange={handleChange("location")}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        value={values.description}
                                        placeholder="Enter Description"
                                        onChange={handleChange("description")}
                                        required
                                      />
                                    </Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                values.auction_status === 1
                                              }
                                              onChange={handleCheckBoxChange(
                                                "auction_status",
                                                1
                                              )}
                                              color="primary"
                                            />
                                          }
                                          label="For Auction"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                values.organic_status === 1
                                              }
                                              onChange={handleCheckBoxChange(
                                                "organic_status",
                                                1
                                              )}
                                              color="primary"
                                            />
                                          }
                                          label="Organic"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={values.safe_status === 1}
                                              onChange={handleCheckBoxChange(
                                                "safe_status",
                                                1
                                              )}
                                              color="primary"
                                            />
                                          }
                                          label="Safe To Eat"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                values.transpot_status === 1
                                              }
                                              onChange={handleCheckBoxChange(
                                                "transpot_status",
                                                1
                                              )}
                                              color="primary"
                                            />
                                          }
                                          label="Transport Available"
                                        />
                                      </Grid>
                                      {values.transpot_status === 1 && (
                                        <>
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Free Delivery Upto KM"
                                              value={values.freeDelivery}
                                              placeholder="Enter KM"
                                              onChange={handleChange(
                                                "freeDelivery"
                                              )}
                                              required
                                            />
                                          </Grid>
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Charges after KM"
                                              value={values.chargesAfter}
                                              placeholder="Enter Price"
                                              onChange={handleChange(
                                                "chargesAfter"
                                              )}
                                              required
                                            />
                                          </Grid>
                                        </>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      onClick={handleShowClose1}
                                      sx={{ mt: 2, mr: 1 }}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      sx={{ mt: 2, mr: 1 }}
                                      style={{
                                        backgroundColor: "#0BAAE5",
                                        marginRight: "10px",
                                      }}
                                    >
                                      {sellPId ? "Update" : "Submit"}
                                    </Button>
                                  </div>
                                </form>
                              </Box>
                            </Modal>

                            <TableContainer>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell width="80px" align="center">
                                      S.No
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Title
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Customer
                                    </TableCell>
                                    <TableCell width="180px" align="left">
                                      Status
                                    </TableCell>
                                    <TableCell width="80px" align="left">
                                      Actions
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filterSell.map((product, index) => (
                                    <TableRow key={product._id}>
                                      <TableCell width="80px" align="center">
                                        {index + 1}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        {product.title}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        {product.customer}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        {getStatusString(product.status)}
                                      </TableCell>
                                      <TableCell width="180px" align="left">
                                        <Action row={product} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                  {/* View Detials of sellProducts */}
                                  <Modal
                                    open={sellView}
                                    // onClose={handleSellViewClose}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                  >
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "80vw",
                                        maxHeight: "80vh",
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 4,
                                        overflowY: "auto",
                                      }}
                                    >
                                      <Grid
                                        container
                                        justifyContent="center"
                                        alignItems="center"
                                        className="modal-content"
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-header"
                                        >
                                          <Typography
                                            id="modal-title"
                                            variant="h6"
                                            component="h2"
                                          >
                                            Details
                                          </Typography>
                                          <Button
                                            onClick={handleSellViewClose}
                                            color="inherit"
                                          >
                                            <span
                                              style={{ fontSize: "20px" }}
                                              aria-hidden="true"
                                            >
                                              &#128473;
                                            </span>
                                          </Button>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-body"
                                        >
                                          <Table className="col-12">
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Title
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.title}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Description
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.description}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Expiry Date
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.expDate}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Available Date
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.availableDate}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                location
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.location}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                latitude
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.latitude}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                longitude
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.longitude}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                keywords
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.keywords
                                                  ? sellDetails.keywords.join(
                                                      ", "
                                                    )
                                                  : "No keywords available"}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                unit
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.unit}
                                              </TableCell>
                                            </TableRow>
                                            <TableRow>
                                              <TableCell className="text-left">
                                                Quantity
                                              </TableCell>
                                              <TableCell className="text-dark text-right font-weight-normal">
                                                {sellDetails.qty}
                                              </TableCell>
                                            </TableRow>
                                          </Table>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          className="modal-footer"
                                        >
                                          <Button
                                            onClick={handleSellViewClose}
                                            variant="outlined"
                                            color="error"
                                          >
                                            Close
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Modal>

                                  <ImageModal open={open2}
                                    handleClose={handleOpenClose}
                                    imageSrc={imageSources}
                                     ></ImageModal>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabPanel>
                          <TabPanel value="3">Tab content for Payment</TabPanel>
                        </TabContext>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Marketplace;
